export default __webpack_public_path__ + "static/media/google-ads.7df2df43.svg";